var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnpin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.98162 13.5136L2.26758 18.2276M9.74637 6.03482L8.44562 7.33556C8.33954 7.44167 8.28647 7.49472 8.22603 7.53687C8.17238 7.57429 8.1145 7.60526 8.05361 7.62915C7.98501 7.65605 7.91144 7.67077 7.7643 7.70019L4.71058 8.31094C3.91699 8.46965 3.5202 8.54901 3.33457 8.75823C3.17284 8.94048 3.09899 9.18439 3.13246 9.42573C3.17087 9.70281 3.45699 9.98889 4.02926 10.5612L9.93404 16.466C10.5063 17.0382 10.7925 17.3244 11.0695 17.3628C11.3109 17.3962 11.5548 17.3224 11.737 17.1606C11.9462 16.9751 12.0255 16.5782 12.1843 15.7846L12.795 12.7309C12.8245 12.5838 12.8392 12.5102 12.8661 12.4416C12.89 12.3807 12.921 12.3229 12.9584 12.2692C13.0005 12.2087 13.0535 12.1557 13.1597 12.0496L14.4604 10.7489C14.5282 10.6811 14.5622 10.6471 14.5995 10.6175C14.6325 10.5912 14.6676 10.5675 14.7044 10.5465C14.7457 10.5228 14.7898 10.504 14.878 10.4661L16.9566 9.57531C17.563 9.31539 17.8663 9.18548 18.004 8.97548C18.1245 8.79185 18.1675 8.5681 18.1239 8.35288C18.074 8.10675 17.8407 7.8735 17.3742 7.40697L13.0883 3.12103C12.6217 2.6545 12.3885 2.42125 12.1424 2.37135C11.9271 2.32772 11.7034 2.37081 11.5198 2.49125C11.3098 2.62899 11.1798 2.93219 10.92 3.53861L10.0291 5.61724C9.99129 5.70542 9.97237 5.74951 9.94879 5.79085C9.92779 5.82759 9.90404 5.86266 9.8777 5.89578C9.84812 5.93307 9.8142 5.96699 9.74637 6.03482Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpin);
export default __webpack_public_path__ + "static/media/Unpin.eb9857f1b81e6ba424bf660b8733798a.svg";
export { ForwardRef as ReactComponent };